import React, { FC } from "react"
import { Button, SafeArea } from "antd-mobile"
import { welfare_leaf } from "~src/constants/network"
import { WelfareItemsType } from "~src/service/welfare/welfare"
import styles from "./index.module.less"
import classNames from "classnames"

interface MockContentProps {
  point: string,
  item: WelfareItemsType,
  onExchange: () => void
}
const MockContent: FC<MockContentProps> = ({ point, item, onExchange }) => {

  return <div className={classNames(styles.mock, "iphone")}>
    <div className={styles["mock-info"]}>
      <span>我的{item.priceUnit}：</span>
      <img className={styles.welfare_integral} src={welfare_leaf} alt="" />
      <span className={styles["mock-num"]}>{point}</span>
    </div>
    <div className={styles["mock-boby"]}>
      <img className={styles.thumbnail} src={item.imgUrl} alt="" />
      <div className={styles["mock-boby-rf"]}>
        <div className={classNames(styles["mock-boby-rf-title"], styles.lineTextOverFlow)}>{item.desc}</div>
        <div className={styles["mock-boby-rf-free"]}>
          <img className={styles.welfare_free} src={welfare_leaf} alt="" />
          <span className={styles["mock-boby-rf-free-text"]}>{item.priceFee}</span>
          <span>{item.priceUnit}</span>
        </div>
        <div className={styles["mock-boby-rf-num"]}>
          <div>
            <span>兑换数量：</span>
            <span className={styles["mock-boby-rf-num-txt"]}>1</span>
          </div>
          <div>
            <span>可兑换数量：</span>
            <span className={styles["mock-boby-rf-num-txt"]}>{item.remainStock ?? 0}</span>
          </div>

        </div>
      </div>
    </div>
    <Button
      loading="auto"
      loadingText="兑换中"
      disabled={!item.remainStock}
      className={styles["mock-boby-btn"]}
      style={{
        "--background-color": "#F4C500",
        "--border-color": "#F4C500",
        "--text-color": "#FFFFFF",
      }}
      block shape='rounded' onClick={onExchange}>
      <span>{item?.remainStock ? '确认兑换' : '已兑完'}</span>
    </Button>
    <SafeArea position='bottom' />
  </div>
}
export default MockContent
